import { render, staticRenderFns } from "./ApprovedLetterHistory.vue?vue&type=template&id=790ce200"
import script from "./ApprovedLetterHistory.vue?vue&type=script&lang=js"
export * from "./ApprovedLetterHistory.vue?vue&type=script&lang=js"
import style0 from "./ApprovedLetterHistory.vue?vue&type=style&index=0&id=790ce200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports